export default __webpack_public_path__ + "static/media/icon10.ed73193c.svg";